<template>
  <div :class="{ 'w-full': fullWidth }">
    <el-select
      ref="select"
      :class="{ 'w-full': fullWidth }"
      v-model="yourData"
      placeholder="选择您的数据"
      :disabled="disabled"
      value-key="id"
      filterable
      multiple
      :filter-method="handleFilter"
      @change="emitMsg"
      @visible-change="handleVisibleChange"
    >
      <!-- 全选按钮 -->
      <div
        class="select-all-wrapper"
        @click.stop
      >
        <el-checkbox
          v-model="isSelectAll"
          :indeterminate="isIndeterminate"
          @change="handleSelectAll"
        >
          全选
        </el-checkbox>
      </div>
      <!-- 网站访问者选项 -->
      <el-option
        value="website-visitor"
        label="网站访问者"
        v-if="!isEdit"
      >
        <div
          class="flex items-center"
          @click.stop="openWebsiteVisitorDialog"
        >
          <el-button
            type="text"
            icon="el-icon-plus"
            class="text-blue-500 hover:text-blue-600"
          />
          <span>网站访问者</span>
        </div>
      </el-option>
      <el-option-group
        v-for="group in filteredDataList"
        :key="group.typeName"
        :label="group.typeName"
      >
        <el-option
          v-for="item in group.userListAudiences"
          :key="item.resourceName"
          :label="item.name"
          :value="item"
        >
          <div class="flex justify-between">
            <span>{{ item.name }}</span>
            <span>{{ item.size }}</span>
          </div>
        </el-option>
      </el-option-group>
    </el-select>
    <!-- 网站访问者弹窗 -->
    <WebsiteVisitorDialog
      :visible.sync="websiteVisitorDialogVisible"
      :currentAccount="currentAccount"
      :data="data"
      @confirm="handleWebsiteVisitorConfirm"
    />
  </div>
</template>
<script>
import { userListAudiences } from '@/api/google/create';
import WebsiteVisitorDialog from './WebsiteVisitorDialog.vue';

export default {
  components: {
    WebsiteVisitorDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    defaultList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      yourDataList: [],
      yourData: [],
      websiteVisitorDialogVisible: false,
      filterQuery: '',
      isSelectAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    // 筛选后的数据列表
    filteredDataList() {
      if (!this.filterQuery) {
        return this.yourDataList;
      }
      const query = this.filterQuery.toLowerCase();
      return this.yourDataList
        .map((group) => ({
          ...group,
          userListAudiences: group.userListAudiences.filter((item) => item.name.toLowerCase().includes(query)),
        }))
        .filter((group) => group.userListAudiences.length > 0);
    },
    // 当前筛选后的所有选项
    filteredOptions() {
      const options = [];
      this.filteredDataList.forEach((group) => {
        group.userListAudiences.forEach((item) => {
          options.push(item);
        });
      });
      return options;
    },
  },
  watch: {
    value: {
      handler() {
        this.yourData = this.value;
        this.updateSelectAllStatus();
      },
      deep: true,
      immediate: true,
    },
    defaultList: {
      handler() {
        if (this.defaultList && this.defaultList.length > 0) {
          this.yourDataList = this.defaultList;
        }
      },
      deep: true,
      immediate: true,
    },
    yourData: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
    filteredOptions: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
  },
  methods: {
    async getYourDataList() {
      let res = await userListAudiences({ accountId: this.currentAccount.id });
      console.log(res, 'yourDataList');
      this.yourDataList = res.data || [];
      this.$emit('setYourDataList', this.yourDataList);
      this.$nextTick(() => {
        this.yourData = this.value;
      });
    },
    // 导出数据
    emitMsg() {
      // 检查是否选中了网站访问者选项
      if (this.yourData.includes('website-visitor')) {
        this.openWebsiteVisitorDialog();
        return;
      }
      this.$emit('input', this.yourData);
    },
    // 打开网站访问者弹窗
    openWebsiteVisitorDialog() {
      // 移除网站访问者选项如果被选中
      this.yourData = this.yourData ? this.yourData.filter((item) => item !== 'website-visitor') : null;
      this.websiteVisitorDialogVisible = true;
      // 关闭下拉框
      this.$refs.select && this.$refs.select.blur();
    },
    // 处理网站访问者确认
    handleWebsiteVisitorConfirm(formData) {
      console.log('网站访问者数据:', formData);
      this.getYourDataList();
      // 这里可以添加创建网站访问者的API调用
    },
    // 自定义筛选方法
    handleFilter(query) {
      this.filterQuery = query;
    },
    // 下拉框显示/隐藏时重置筛选
    handleVisibleChange(visible) {
      if (!visible) {
        this.filterQuery = '';
      }
    },
    // 全选/取消全选
    handleSelectAll(val) {
      if (val) {
        // 全选：将筛选后的所有选项添加到已选中
        const currentIds = (this.yourData || []).map((item) => item.id);
        const newItems = this.filteredOptions.filter((item) => !currentIds.includes(item.id));
        this.yourData = [...(this.yourData || []), ...newItems];
      } else {
        // 取消全选：移除筛选后的所有选项
        const filteredIds = this.filteredOptions.map((item) => item.id);
        this.yourData = (this.yourData || []).filter((item) => !filteredIds.includes(item.id));
      }
      this.$emit('input', this.yourData);
    },
    // 更新全选状态
    updateSelectAllStatus() {
      if (!this.filteredOptions.length) {
        this.isSelectAll = false;
        this.isIndeterminate = false;
        return;
      }
      const selectedIds = (this.yourData || []).map((item) => item.id);
      const filteredIds = this.filteredOptions.map((item) => item.id);
      const selectedCount = filteredIds.filter((id) => selectedIds.includes(id)).length;

      this.isSelectAll = selectedCount === filteredIds.length;
      this.isIndeterminate = selectedCount > 0 && selectedCount < filteredIds.length;
    },
  },
};
</script>
<style lang="scss" scoped>
.select-all-wrapper {
  padding: 8px 20px;
  border-bottom: 1px solid #e4e7ed;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
</style>
